module.exports = "/static/media/nucleus-app-icon-n-reversed-vibrant-256.0eab65f8.png";